Apt.fn.extend('profile', {}, {
	/**
	 * Load profile property map
	 */
	initMap() {
		const scope = this;

		if (window.crawler) {
			scope.loadMap();

			return;
		}

		LS.api.get(`profiles/${scope.id}/points`, {
			success: data => {
				const points = data.results;

				if (points.length) {
					scope.loadMap(points);
				} else {
					$$('profileMap').remove();
				}
			}
		});
	},

	/**
	 * Load map
	 *
	 * @param {Array} [points]
	 */
	loadMap(points) {
		const scope = this;

		LS.util.load('maps', () => {
			scope.addMap(points);
		});
	},

	/**
	 * Create map instance
	 *
	 * @param {Array} [points]
	 */
	addMap(points) {
		const scope = this;

		scope.map = Apt.fn.maps()
			.init('$profileMap', {
				hideZoomMessage: true,
				reset: true,
				points: points,
				countData: {
					profile_id: scope.id // eslint-disable-line
				},
				territoryData: {
					agent_id: scope.id // eslint-disable-line
				},
				onClick: (id, map, feature) => {
					Apt.properties.showTooltip(id, map, feature);
				},
				onClusterEnter: (map, features) => {
					Apt.properties.showCluster(map, features);
				}
			});
	}
});